







import {
  computed,
  defineComponent,
} from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'ProductTitle',
  props: {
    title: {
      type: String,
      default: '',
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const escapeHtml = (unsafe) => unsafe
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');

    const formattedTitle = computed(() => escapeHtml(props.title).replace(/\([^()]*\)/g, '<span class="inline-block">$&</span>'));

    return {
      formattedTitle,
    };
  },
});
